/* ===========================================================================
   Upload
   =========================================================================== */

import { activeClass, hideClass } from "../settings/settings";
import { showAjaxCallbackMessage } from "./ajaxCallback";
import { checkStepValidation } from './step';

const MAX_UPLOAD_SIZE = 4;
const FILE_JPG_FORMATS = ["image/jpg", "image/jpeg"];
const FILE_FORMATS = [...FILE_JPG_FORMATS, "image/png"];

export class Upload {
  constructor(preview, file, buttonRemove = null, wording, deleteCheckbox = null) {
    this.preview = preview;
    this.file = file;
    this.buttonRemove = buttonRemove;
    this.wording = wording;
    this.deleteCheckbox = deleteCheckbox;
  }

  cloneCanvas($oldCanvas) {
    // Create a new canvas
    const newCanvas = document.createElement('canvas');
    const context = newCanvas.getContext('2d');

    // Set dimensions
    newCanvas.width = $oldCanvas.width;
    newCanvas.height = $oldCanvas.height;

    // Apply the old canvas to the new one
    context.drawImage($oldCanvas, 0, 0);

    // Return the new canvas
    return newCanvas;
  }

  clearCanvas() {
    const $canvas = this.preview
      .closest(".js-upload-container")
      .querySelector("canvas");

      const $canvasSecondary = document.querySelector(".js-item-selected-image canvas");

    if ($canvas) {
      $canvas.remove();
    }

    if ($canvasSecondary) {
      $canvasSecondary.remove();
    }
  }

  previewFile(primary) {
    const file = this.file;
    const $imagePrimary = document.getElementById("js-imagePrimary");
    const isImagePrimary = $imagePrimary && primary;
    const isJpgFormat = FILE_JPG_FORMATS.includes(file.type);
    const isWrongFormat = !FILE_FORMATS.includes(file.type);
    const isTooBig = file.size / 1000000 > MAX_UPLOAD_SIZE;
    const reader = new FileReader();

    return new Promise((resolve, reject) => {

      if (isWrongFormat) {
        return reject(this.preview.getAttribute("data-wrong-format"));
      } else if (isTooBig) {
        return reject(this.preview.getAttribute("data-too-big-size"));
      }

      if (isImagePrimary) {
        this.clearCanvas();
      }

      reader.addEventListener('load', event => {

        if (isJpgFormat) {

          const exif = piexif.load(event.target.result);
          const image = new Image();

          image.addEventListener('load', () => {
            const orientation = exif["0th"][piexif.ImageIFD.Orientation];

            if (orientation) {
              const canvas = document.createElement("canvas");
              canvas.width = image.width;
              canvas.height = image.height;

              const ctx = canvas.getContext("2d");
              let x = 0;
              let y = 0;

              ctx.save();

              switch (true) {
                case orientation === 2:
                  x = -canvas.width;
                  ctx.scale(-1, 1);
                  break;
                case orientation === 3:
                  x = -canvas.width;
                  y = -canvas.height;
                  ctx.scale(-1, -1);
                  break;
                case orientation === 4:
                  y = -canvas.height;
                  ctx.scale(1, -1);
                  break;
                case orientation === 5:
                  canvas.width = image.height;
                  canvas.height = image.width;
                  ctx.translate(canvas.width, canvas.height / canvas.width);
                  ctx.rotate(Math.PI / 2);
                  y = -canvas.width;
                  ctx.scale(1, -1);
                  break;
                case orientation === 6:
                  canvas.width = image.height;
                  canvas.height = image.width;
                  ctx.translate(canvas.width, canvas.height / canvas.width);
                  ctx.rotate(Math.PI / 2);
                  break;
                case orientation === 7:
                  canvas.width = image.height;
                  canvas.height = image.width;
                  ctx.translate(canvas.width, canvas.height / canvas.width);
                  ctx.rotate(Math.PI / 2);
                  x = -canvas.height;
                  ctx.scale(-1, 1);
                  break;
                case orientation === 8:
                  canvas.width = image.height;
                  canvas.height = image.width;
                  ctx.translate(canvas.width, canvas.height / canvas.width);
                  ctx.rotate(Math.PI / 2);
                  x = -canvas.height;
                  y = -canvas.width;
                  ctx.scale(-1, -1);
                  break;
              }

              ctx.drawImage(image, x, y);
              ctx.restore();

              $(canvas).insertBefore($(this.preview));

              if (isImagePrimary) {
                const $clone = this.cloneCanvas(canvas);
                $($clone).insertBefore($($imagePrimary));
              }
            } else {
              this.preview.src = event.target.result;
            }
            if (this.buttonRemove) {
              this.buttonRemove.classList.remove(hideClass);
            }
            this.wording.innerHTML = file.name;
          });

          image.src = event.target.result;

        } else {

          this.preview.src = reader.result;
          this.wording.innerHTML = file.name;
          if (this.buttonRemove) {
            this.buttonRemove.classList.remove(hideClass);
          }
        }

        if (this.deleteCheckbox) {
          this.deleteCheckbox.checked = false;
        }

        if ($imagePrimary && primary) {
          $imagePrimary.src = isJpgFormat ? event.target.result : reader.result;
        }
      });

      resolve(reader.readAsDataURL(file));

    });
  }
}

/**
 * [showPreviewFile description]
 * @param  {[type]} $this [description]
 * @return {[type]}       [description]
 */
export function showPreviewFile($this) {
  const $parent = $this.closest(".js-upload-container");
  const options = [
    $this.parentNode.querySelector(".js-file-image"),
    $this.files[0],
    $this.parentNode.querySelector(".js-remove-file"),
    $this.parentNode.querySelector(".js-file-wording"),
    $parent.querySelector(".js-edit-delete-picture")
  ];
  const upload = new Upload(...options);

  return upload
    .previewFile($this.classList.contains("js-primary-picture"))
    .then(() => $parent.classList.add(activeClass))
    .catch(error => {
      showAjaxCallbackMessage(error);
      return Promise.reject(error);
    });
}

/**
 * Clear input value
 * @param {[DOM]} $input
 */
export function clearInput($input) {
  $($input).replaceWith($($input).val("").clone(true));
};

/**
 * [removePreviewFile description]
 * @param  {[type]} $this [description]
 * @return {[type]}       [description]
 */
export function removePreviewFile($this) {
  const $parent = $this.closest(".js-upload-container");
  const options = [
    $this,
    $this.parentNode.parentNode.querySelector(".js-file-upload"),
    $this.parentNode.querySelector(".js-file-image"),
    $this.parentNode.querySelector(".js-file-wording")
  ];

  clearUpload(...options);

  $parent.classList.remove(activeClass);
}

/**
 * [clearUpload description]
 * @return {[type]} [description]
 */
export function clearUpload($this, $input, $preview, $wording) {
  const defaultImage = $preview.getAttribute("data-default-src");
  const $canvas = $this.closest(".js-upload-container").querySelector('canvas');
  const $deleteCheckbox = $this.closest(".js-upload-container").querySelector(".js-edit-delete-picture");

  if ($canvas) {
    $canvas.remove();
  }
  // Reset previewFile
  $preview.setAttribute("src", defaultImage);

  // Reset input file
  clearInput($input);
  checkStepValidation($($this));

  // Reset wording
  $wording.innerHTML = $wording.getAttribute("data-default-wording");

  // If edit form, checked if we have to manage delete checkbox
  if ($deleteCheckbox) {
    $deleteCheckbox.checked = true;
  }
}

$(".js-user-picture-upload").on("change", function(e) {
  $(this)
    .parent("form")
    .submit();
});

function inputFile() {
  // https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
  $('.custom-input-file').each( function()
  {
    let $input	 = $(this),
      $label	 = $input.next('.custom-input-file-label'),
      labelVal = $label.html();

    $input.on( 'change', function(e) {
      let fileName = '';

      if(this.files && this.files.length > 1)
        fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
      else if(e.target.value)
        fileName = e.target.value.split( '\\' ).pop();

      if(fileName)
        $label.find('.file-label').html(fileName);
      else
        $label.html( labelVal );
    });

    // Firefox bug fix
    $input
      .on('focus', function(){ $input.addClass('has-focus'); })
      .on('blur', function(){ $input.removeClass('has-focus'); });
  });
}

inputFile();
